/* eslint-disable react/prop-types */
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ArgonButton from "components/ArgonButton";
import { Link } from "react-router-dom";

const FaQTableData = (faqs, handleDeleteClick) => ({
  columns: [
    { name: "sno", align: "center" },
    { name: "type", align: "center" },
    { name: "plan_faq", align: "center" },
    { name: "question", align: "left" },
    { name: "answer", align: "left" },
    { name: "created_at", align: "center" },
    { name: "action", align: "center" },
  ],

  rows:
    faqs?.map((faq, index) => ({
      sno: (
        <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
          {index + 1}
        </ArgonTypography>
      ),
      type: (
        <ArgonBadge
          variant="gradient"
          badgeContent={faq.FaQType}
          color={faq.FaQType === "PARENT" ? "info" : "success"}
          size="xs"
          container
        />
      ),
      plan_faq: (
        <ArgonBadge
          variant="gradient"
          badgeContent={faq.isPlanFaQ ? "Yes" : "No"}
          color={faq.isPlanFaQ ? "success" : "secondary"}
          size="xs"
          container
        />
      ),
      question: (
        <ArgonBox maxWidth="300px">
          <ArgonTypography
            variant="caption"
            color="text"
            fontWeight="medium"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {faq.question}
          </ArgonTypography>
        </ArgonBox>
      ),
      answer: (
        <ArgonBox maxWidth="350px">
          <ArgonTypography
            variant="caption"
            color="secondary"
            sx={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {faq.answer}
          </ArgonTypography>
        </ArgonBox>
      ),
      created_at: (
        <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
          {new Date(faq.createdAt).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </ArgonTypography>
      ),
      action: (
        <ArgonBox display="flex" alignItems="center" gap={0.5}>
          <Link to={`/faq/view/${faq._id}`}>
            <ArgonButton
              variant="text"
              color="info"
              size="small"
              iconOnly
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(0, 117, 255, 0.1)",
                },
              }}
            >
              <VisibilityIcon fontSize="small" />
            </ArgonButton>
          </Link>

          <Link to={`/faq/edit/${faq._id}`}>
            <ArgonButton
              variant="text"
              color="warning"
              size="small"
              iconOnly
              sx={{
                "&:hover": {
                  backgroundColor: "rgba(255, 152, 0, 0.1)",
                },
              }}
            >
              <EditIcon fontSize="small" />
            </ArgonButton>
          </Link>

          <ArgonButton
            variant="text"
            color="error"
            size="small"
            iconOnly
            onClick={() => handleDeleteClick(faq)}
            sx={{
              "&:hover": {
                backgroundColor: "rgba(244, 67, 54, 0.1)",
              },
            }}
          >
            <DeleteIcon fontSize="small" />
          </ArgonButton>
        </ArgonBox>
      ),
    })) || [],
});

export default FaQTableData;
